import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CssBaseline, Container, Typography, Box, Button, Chip, Skeleton, LinearProgress, TextField, Dialog, DialogTitle, DialogContent, IconButton, Tooltip, CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import { injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/header-menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RefreshIcon from '@mui/icons-material/Refresh';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Api from '../../services/api';
import MarketingService, { normalizeReport, normalizeSentMessage, normalizeRun } from '../../services/marketing.service';
import moment from 'moment';

const fmtDate = (s) => (s ? moment(s).format('DD/MM/YYYY HH:mm') : '—');

// Custo unitário por categoria Meta (US$) — usado quando o backend não devolve o preço.
const PRICING = { Marketing: 0.0625, Utility: 0.0080, Authentication: 0.0315 };

// Ícone por ação da auditoria (a auditoria do backend usa: created/scheduled/sent/completed).
const AUDIT_ICON = {
  created: <PersonAddOutlinedIcon sx={{ fontSize: 16 }} />,
  edited: <EditOutlinedIcon sx={{ fontSize: 16 }} />,
  scheduled: <ScheduleOutlinedIcon sx={{ fontSize: 16 }} />,
  sent: <SendOutlinedIcon sx={{ fontSize: 16 }} />,
  paused: <PauseCircleOutlineIcon sx={{ fontSize: 16 }} />,
  completed: <DoneAllIcon sx={{ fontSize: 16 }} />,
};
const CONTACT_STATUS = {
  queued:    { color: '#8a8a8a', bg: '#f1f1f1' },
  sent:      { color: '#277afe', bg: '#e8f1ff' },
  delivered: { color: '#5b9b1e', bg: '#eef7e3' },
  read:      { color: '#0a7d4d', bg: '#e1f6ec' },
  replied:   { color: '#7b1fa2', bg: '#f3e5f9' },
  failed:    { color: '#c0392b', bg: '#fdecea' },
  cancelled: { color: '#8a6d3b', bg: '#fbf3e2' },
};

class MarketingBroadcastReport extends Component {
  constructor(props) {
    super(props);
    this.broadcastId = props.match && props.match.params ? props.match.params.id : null;
    // Execução a exibir: ?runId= da URL (default: a mais recente, resolvida pelo backend).
    const runFromUrl = new URLSearchParams(props.location ? props.location.search : '').get('runId');
    this.state = { loading: true, report: null, contactFilter: 'all',
      runs: [], selectedRunId: runFromUrl ? Number(runFromUrl) : null,
      msgDialog: { open: false, loading: false, contact: null, data: null, error: null } };
  }
  componentDidMount() { this.loadRuns(); this.loadReport(); }

  // Histórico de execuções (seletor). Se ainda não há run selecionado, adota o mais recente.
  loadRuns = () => {
    MarketingService.getBroadcastRuns(this.broadcastId)
      .then(result => {
        const runs = (result.data && result.data.success && Array.isArray(result.data.data))
          ? result.data.data.map(normalizeRun) : [];
        this.setState(prev => ({ runs, selectedRunId: prev.selectedRunId || (runs[0] ? runs[0].id : null) }));
      })
      .catch(() => this.setState({ runs: [] }));
  };

  changeRun = (runId) => this.setState({ selectedRunId: runId }, this.loadReport);
  get lang() { return (window.location.pathname.split('/')[1]) || 'pt'; }

  // Volta pra lista na ABA de origem: usa o ?tab= que veio na URL; senão, deriva do status da transmissão.
  backToList = () => {
    const fromUrl = new URLSearchParams(this.props.location ? this.props.location.search : '').get('tab');
    const tab = fromUrl || (this.state.report ? this.state.report.status : '');
    this.props.history.push(`/${this.lang}/marketing${tab ? `?tab=${tab}` : ''}`);
  };

  loadReport = () => {
    this.setState({ loading: true });
    const status = this.state.contactFilter === 'all' ? null : this.state.contactFilter;
    MarketingService.getReport(this.broadcastId, 1, 200, status, this.state.selectedRunId)
      .then(result => {
        const report = (result.data && result.data.success) ? normalizeReport(result.data.data) : null;
        // Alinha o run selecionado ao que o backend efetivamente usou (ex.: default = mais recente).
        this.setState({ report, loading: false, selectedRunId: (report && report.runId) || this.state.selectedRunId });
      })
      .catch(err => { this.setState({ loading: false }); Api.kickoff(err); });
  };

  changeContactFilter = (v) => this.setState({ contactFilter: v && v.id ? v.id : 'all' }, this.loadReport);

  doExport = async () => {
    try {
      const result = await MarketingService.exportReport(this.broadcastId, this.state.selectedRunId);
      const blob = new Blob([result.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `marketing-broadcast-${this.broadcastId}${this.state.selectedRunId ? `-run${this.state.selectedRunId}` : ''}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) { Api.kickoff(err); }
  };

  rate = (n, d) => d > 0 ? Math.round((n / d) * 100) : 0;
  filteredContacts = () => (this.state.report && this.state.report.contacts) ? this.state.report.contacts : [];

  // Mensagem disparada: abre o modal e busca o corpo via endpoint.
  openMessage = async (c) => {
    this.setState({ msgDialog: { open: true, loading: true, contact: c, data: null, error: null } });
    try {
      const result = await MarketingService.getSentMessage(this.broadcastId, c.id);
      if (result.data && result.data.success) {
        this.setState(prev => ({ msgDialog: { ...prev.msgDialog, loading: false, data: normalizeSentMessage(result.data.data) } }));
      } else {
        const e = result.data && result.data.errors && result.data.errors[0];
        this.setState(prev => ({ msgDialog: { ...prev.msgDialog, loading: false, error: e || this.props.intl.formatMessage({ id: 'marketing.message.notFound' }) } }));
      }
    } catch (err) {
      this.setState(prev => ({ msgDialog: { ...prev.msgDialog, loading: false, error: this.props.intl.formatMessage({ id: 'marketing.message.notFound' }) } }));
      Api.kickoff(err);
    }
  };

  closeMessage = () => this.setState({ msgDialog: { open: false, loading: false, contact: null, data: null, error: null } });

  metricCard(labelId, value, color) {
    const { intl } = this.props;
    return (
      <Box sx={{ flex: 1, minWidth: 130, border: '1px solid #e0e0e0', borderRadius: '10px', p: 1.5, backgroundColor: '#fff' }}>
        <Typography sx={{ fontSize: 24, fontWeight: 700, color }}>{value.toLocaleString('pt-BR')}</Typography>
        <Typography sx={{ fontSize: 12, color: '#888' }}>{intl.formatMessage({ id: labelId })}</Typography>
      </Box>
    );
  }

  rateBar(labelId, pct, color) {
    const { intl } = this.props;
    return (
      <Box sx={{ flex: 1, minWidth: 180 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography sx={{ fontSize: 13, color: '#666' }}>{intl.formatMessage({ id: labelId })}</Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 700, color }}>{pct}%</Typography>
        </Box>
        <LinearProgress variant="determinate" value={pct} sx={{ height: 8, borderRadius: 4, backgroundColor: '#eee', '& .MuiLinearProgress-bar': { backgroundColor: color } }} />
      </Box>
    );
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu, intl } = this.props;
    const { loading } = this.state;
    const report = this.state.report;
    const t = (report && report.totals) || { valid: 0, invalid: 0, sent: 0, delivered: 0, read: 0, replied: 0, failed: 0 };
    const timeline = (report && report.timeline && report.timeline.length) ? report.timeline : [0];
    const maxTl = Math.max(...timeline, 1);
    // Categoria saiu do fluxo de template → transmissão é sempre Marketing; cai no preço Marketing quando o back não devolve.
    const costUnit = (report && (PRICING[report.category] != null ? PRICING[report.category] : report.costUnit)) || PRICING.Marketing;

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open }, classes.actionsContent, { [classes.actionscontentShift]: actionsHeaderMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={this.backToList} sx={{ textTransform: 'none', color: '#666' }}>{intl.formatMessage({ id: 'marketing.back.list' })}</Button>
                <AssessmentOutlinedIcon sx={{ color: '#5b9b1e' }} />
                <Box>
                  <Typography sx={{ fontSize: 20, fontWeight: 700, color: '#333', lineHeight: 1.1 }}>{report ? report.name : ''}</Typography>
                  <Typography sx={{ fontSize: 12, color: '#888' }}>{intl.formatMessage({ id: 'marketing.report.title' })}</Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Tooltip title={intl.formatMessage({ id: 'marketing.report.refresh' })}>
                  <span>
                    <IconButton onClick={this.loadReport} disabled={loading}
                      sx={{ border: '1px solid #cfcfcf', borderRadius: '8px', color: '#8BC34A', width: 40, height: 40, '&:hover': { backgroundColor: '#f1f8e9', borderColor: '#8BC34A' } }}>
                      {loading ? <CircularProgress size={18} sx={{ color: '#8BC34A' }} /> : <RefreshIcon fontSize="small" />}
                    </IconButton>
                  </span>
                </Tooltip>
                <Button variant="outlined" startIcon={<FileDownloadOutlinedIcon />} onClick={this.doExport} sx={{ textTransform: 'none' }}>
                  {intl.formatMessage({ id: 'marketing.report.exportCsv' })}
                </Button>
              </Box>
            </Box>

            {/* Seletor de execução (histórico) — aparece quando há execuções (recorrentes têm várias) */}
            {this.state.runs.length > 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, flexWrap: 'wrap' }}>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#555' }}>{intl.formatMessage({ id: 'marketing.report.run' })}</Typography>
                <TextField select size="small" SelectProps={{ native: true }} sx={{ minWidth: 320 }}
                  value={this.state.selectedRunId || ''} onChange={(e) => this.changeRun(Number(e.target.value))}>
                  {this.state.runs.map(r => (
                    <option key={r.id} value={r.id}>
                      {`#${r.runNumber} · ${fmtDate(r.at)} · ${r.sent} ${intl.formatMessage({ id: 'marketing.report.sent' })}${r.failed ? ` · ${r.failed} ${intl.formatMessage({ id: 'marketing.report.failed' })}` : ''}`}
                    </option>
                  ))}
                </TextField>
                <Typography sx={{ fontSize: 12, color: '#999' }}>{intl.formatMessage({ id: 'marketing.report.runCount' }, { n: this.state.runs.length })}</Typography>
              </Box>
            )}

            {(loading || !report) ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Skeleton variant="rounded" height={90} animation="wave" />
                <Skeleton variant="rounded" height={120} animation="wave" />
                <Skeleton variant="rounded" height={240} animation="wave" />
              </Box>
            ) : (
              <>
                {/* Totais */}
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
                  {this.metricCard('marketing.recipients.valid', t.valid, '#5b9b1e')}
                  {this.metricCard('marketing.recipients.invalid', t.invalid, '#c0392b')}
                  {this.metricCard('marketing.report.sent', t.sent, '#277afe')}
                  {this.metricCard('marketing.report.delivered', t.delivered, '#5b9b1e')}
                  {this.metricCard('marketing.report.read', t.read, '#0a7d4d')}
                  {this.metricCard('marketing.report.replied', t.replied, '#7b1fa2')}
                  {this.metricCard('marketing.report.failed', t.failed, '#c0392b')}
                </Box>

                {/* Taxas */}
                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', p: 2, backgroundColor: '#fff', mb: 2 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1.5 }}>{intl.formatMessage({ id: 'marketing.report.rates' })}</Typography>
                  <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                    {this.rateBar('marketing.report.deliveryRate', this.rate(t.delivered, t.sent), '#5b9b1e')}
                    {this.rateBar('marketing.report.readRate', this.rate(t.read, t.delivered), '#0a7d4d')}
                    {this.rateBar('marketing.report.replyRate', this.rate(t.replied, t.delivered), '#7b1fa2')}
                  </Box>
                </Box>

                {/* Custo estimado por categoria Meta (req. seção 4) */}
                <Box sx={{ border: '1px solid #ffe0b2', borderRadius: '12px', p: 2, backgroundColor: '#fff8ef', mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#b9770e' }}>{intl.formatMessage({ id: 'marketing.cost.title' })}</Typography>
                  {report.category && (
                    <Chip size="small" label={report.category} sx={{ borderRadius: '6px', backgroundColor: '#fff', color: '#b9770e', border: '1px solid #ffd9a0' }} />
                  )}
                  <Typography sx={{ fontSize: 13, color: '#555' }}>{intl.formatMessage({ id: 'marketing.cost.unit' })}: <b>US$ {costUnit.toFixed(4)}</b></Typography>
                  <Typography sx={{ fontSize: 13, color: '#555' }}>{intl.formatMessage({ id: 'marketing.report.sent' })}: <b>{t.sent.toLocaleString('pt-BR')}</b></Typography>
                  <Box sx={{ flex: 1 }} />
                  <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#b9770e' }}>{intl.formatMessage({ id: 'marketing.cost.total' })}: US$ {(costUnit * t.sent).toFixed(2)}</Typography>
                </Box>

                {/* Timeline (gráfico de barras simples) */}
                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', p: 2, backgroundColor: '#fff', mb: 2 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1.5 }}>{intl.formatMessage({ id: 'marketing.report.timeline' })}</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, height: 120 }}>
                    {timeline.map((v, i) => (
                      <Box key={i} sx={{ flex: 1, backgroundColor: '#8BC34A', borderRadius: '4px 4px 0 0', height: `${(v / maxTl) * 100}%`, opacity: 0.85 }} title={`${v}`} />
                    ))}
                  </Box>
                  <Typography sx={{ fontSize: 11, color: '#aaa', mt: 0.5, textAlign: 'center' }}>{intl.formatMessage({ id: 'marketing.report.timelineNote' })}</Typography>
                </Box>

                {/* Nível contato */}
                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#fff' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1.5, flexWrap: 'wrap', gap: 1 }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{intl.formatMessage({ id: 'marketing.report.byContact' })}</Typography>
                    <Box sx={{ minWidth: 220 }}>
                      {(() => {
                        const opts = [{ id: 'all', name: intl.formatMessage({ id: 'marketing.report.filterAll' }) },
                          ...['sent', 'delivered', 'read', 'replied', 'failed'].map(s => ({ id: s, name: intl.formatMessage({ id: `marketing.cstatus.${s}` }) }))];
                        return <SimpleAutoComplete label={intl.formatMessage({ id: 'marketing.report.filterStatus' })} options={opts} size="small" stateName="f"
                          selected={opts.find(o => o.id === this.state.contactFilter) || opts[0]}
                          changeSelect={(n, v) => this.changeContactFilter(v)} />;
                      })()}
                    </Box>
                  </Box>
                  <Box sx={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 640 }}>
                      <thead><tr style={{ backgroundColor: '#fafafa' }}>
                        {['marketing.list.col.name', 'marketing.col.sender', 'marketing.col.status', 'marketing.report.timestamp', 'marketing.report.error'].map(h => (
                          <th key={h} style={{ textAlign: 'left', padding: '10px 12px', fontSize: 12, color: '#888', fontWeight: 600 }}>{intl.formatMessage({ id: h })}</th>
                        ))}
                        <th style={{ textAlign: 'center', padding: '10px 12px', fontSize: 12, color: '#888', fontWeight: 600, whiteSpace: 'nowrap' }}>{intl.formatMessage({ id: 'marketing.report.message' })}</th>
                      </tr></thead>
                      <tbody>
                        {this.filteredContacts().map((c, i) => {
                          const meta = CONTACT_STATUS[c.status] || CONTACT_STATUS.queued;
                          return (
                            <tr key={i}>
                              <td style={{ padding: 12, fontSize: 13, borderTop: '1px solid #f0f0f0' }}>{c.name}</td>
                              <td style={{ padding: 12, fontSize: 13, borderTop: '1px solid #f0f0f0', whiteSpace: 'nowrap' }}>{c.phone}</td>
                              <td style={{ padding: 12, borderTop: '1px solid #f0f0f0' }}>
                                <Chip size="small" label={intl.formatMessage({ id: `marketing.cstatus.${c.status}` })} sx={{ borderRadius: '6px', backgroundColor: meta.bg, color: meta.color, fontWeight: 600 }} />
                              </td>
                              <td style={{ padding: 12, fontSize: 13, borderTop: '1px solid #f0f0f0', whiteSpace: 'nowrap' }}>{fmtDate(c.at)}</td>
                              <td style={{ padding: 12, fontSize: 12, borderTop: '1px solid #f0f0f0', color: '#c0392b' }}>{c.error || '—'}</td>
                              <td style={{ padding: 12, borderTop: '1px solid #f0f0f0', textAlign: 'center' }}>
                                {c.hasMessage ? (
                                  <Tooltip title={intl.formatMessage({ id: 'marketing.report.viewMessage' })}>
                                    <IconButton size="small" onClick={() => this.openMessage(c)} sx={{ color: '#5b9b1e' }}>
                                      <ChatOutlinedIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                ) : <span style={{ color: '#ccc' }}>—</span>}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Box>
                </Box>

                {/* Auditoria (req. seção 4): quem criou/editou/pausou/cancelou/enviou */}
                <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', p: 2, backgroundColor: '#fff', mt: 2 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 1.5 }}>{intl.formatMessage({ id: 'marketing.audit.title' })}</Typography>
                  {report.audit.map((a, i) => (
                    <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.8, borderTop: i ? '1px solid #f5f5f5' : 'none' }}>
                      <Box sx={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#eef7e3', color: '#5b9b1e', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        {AUDIT_ICON[a.icon]}
                      </Box>
                      <Typography sx={{ fontSize: 13, color: '#333', flex: 1 }}>
                        <b>{a.who}</b> {intl.formatMessage({ id: a.actKey })}
                      </Typography>
                      <Typography sx={{ fontSize: 12, color: '#999', whiteSpace: 'nowrap' }}>{fmtDate(a.at)}</Typography>
                    </Box>
                  ))}
                </Box>
              </>
            )}
          </Container>

          {/* Modal: mensagem efetivamente disparada para o contato */}
          <Dialog open={this.state.msgDialog.open} onClose={this.closeMessage} maxWidth="sm" fullWidth
            PaperProps={{ sx: { borderRadius: '12px' } }}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 6 }}>
              <ChatOutlinedIcon sx={{ color: '#5b9b1e' }} />
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#333', lineHeight: 1.2 }}>
                  {intl.formatMessage({ id: 'marketing.report.viewMessage' })}
                </Typography>
                {this.state.msgDialog.contact && (
                  <Typography sx={{ fontSize: 12, color: '#888' }}>
                    {this.state.msgDialog.contact.name} · {this.state.msgDialog.contact.phone}
                  </Typography>
                )}
              </Box>
              <IconButton onClick={this.closeMessage} size="small" sx={{ position: 'absolute', right: 12, top: 12, color: '#999' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {this.state.msgDialog.loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}><CircularProgress sx={{ color: '#8BC34A' }} /></Box>
              ) : this.state.msgDialog.error ? (
                <Typography sx={{ fontSize: 14, color: '#c0392b', py: 3, textAlign: 'center' }}>{this.state.msgDialog.error}</Typography>
              ) : (
                <>
                  {/* Balão estilo WhatsApp com o corpo renderizado */}
                  <Box sx={{ backgroundColor: '#dcf8c6', borderRadius: '10px', p: 2, mt: 1, position: 'relative', border: '1px solid #c7ecb0' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1, color: '#5b9b1e' }}>
                      <WhatsAppIcon sx={{ fontSize: 16 }} />
                      <Typography sx={{ fontSize: 11, fontWeight: 700 }}>WhatsApp</Typography>
                    </Box>
                    <Typography sx={{ fontSize: 14, color: '#222', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {(this.state.msgDialog.data && this.state.msgDialog.data.body) || intl.formatMessage({ id: 'marketing.message.empty' })}
                    </Typography>
                    {this.state.msgDialog.data && this.state.msgDialog.data.sentAt && (
                      <Typography sx={{ fontSize: 10, color: '#7a9b5e', textAlign: 'right', mt: 0.5 }}>{fmtDate(this.state.msgDialog.data.sentAt)}</Typography>
                    )}
                  </Box>
                </>
              )}
            </DialogContent>
          </Dialog>

          <Footer />
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({ headerMenu: state.headerMenu, actionsHeaderMenu: state.actionsHeaderMenu, userSession: state.userSession });
const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(MarketingBroadcastReport)));
